module.exports = __webpack_public_path__ + "static/media/ce.d5231f30.d5231f30.jpg";